<template>
  <div clas="app-container banner">
    <div clas="banner-list">
      <div class="banner-list-top">
        <div class="banner-list-top-left">共有 {{tableData.length}} 张图片</div>
        <div class="banner-list-top-right">
          <div class="banner-list-top-right-text">
            <label>格式为png、jpeg、jpg、gif，尺寸为686*320&emsp;</label>
          </div>
          <div class="banner-list-top-right-button">
            <el-button @click="showMaterialSelector = true" size="small">添加图片
            </el-button>
            <el-button @click="onClickSyncCache" size="small">同步缓存
            </el-button>
            <el-button @click="onClickRemoveCache" size="small">清除缓存
            </el-button>
          </div>
        </div>
      </div>
      <div class="banner-list-item"  v-for="(item,index) in tableData" :key="index">
        <div class="banner-list-item-content">
          <div>
            <img :src=item.imgUrl class="banner-list-item-content-img">
          </div>
          <div class="banner-list-item-content-description">
            <div class="banner-list-item-content-description-row">
              <div class="banner-list-item-content-description-row-left">
                <label>图片链接&emsp;</label>
                <lable v-show="!item.isEdit" class="lableText">{{item.link | formatEmptyData | formatDataLength(20)}}</lable>
                <el-input type="text" class="banner-list-item-content-description-row-input" v-show="item.isEdit" v-model="item.link"></el-input>
              </div>
              <div class="banner-list-item-content-description-row-right">
                <label>图片顺序&emsp;</label>
                <lable v-show="!item.isEdit" class="lableText">{{item.sort | formatEmptyData | formatDataLength(20)}}</lable>
                <el-input type="number" :min="0" class="banner-list-item-content-description-row-input" v-show="item.isEdit" v-model="item.sort"></el-input>
              </div>
            </div>
            <div class="banner-list-item-content-description-row">
              <div class="banner-list-item-content-description-row-left">
                <label>图片描述&emsp;</label>
                <lable v-show="!item.isEdit" class="lableText">{{item.description | formatEmptyData | formatDataLength(10)}}</lable>
                <el-input type="text" class="banner-list-item-content-description-row-input" v-show="item.isEdit" v-model="item.description" maxlength="30"></el-input>
              </div>
              <div class="banner-list-item-content-description-row-right">
                <label>图片描述（英文）&emsp;</label>
                <lable v-show="!item.isEdit" class="lableText">{{item.descriptionEn | formatEmptyData | formatDataLength(15)}}</lable>
                <el-input type="text" class="banner-list-item-content-description-row-input-en" v-show="item.isEdit" v-model="item.descriptionEn" maxlength="30"></el-input>
              </div>
            </div>
            <div class="banner-list-item-content-description-row">
              <div class="banner-list-item-content-description-row-left">
                <label>开始时间&emsp;</label>
                <lable v-show="!item.isEdit" class="lableText">{{item.startTime | formatEmptyData }}</lable>
                <el-date-picker class="banner-list-item-content-description-row-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  v-model="item.startTime"
                  v-show="item.isEdit">
                </el-date-picker>
              </div>
              <div class="banner-list-item-content-description-row-right">
                <label>结束时间&emsp;</label>
                <lable v-show="!item.isEdit" class="lableText">{{item.endTime | formatEmptyData }}</lable>
                <el-date-picker class="banner-list-item-content-description-row-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  v-model="item.endTime"
                  v-show="item.isEdit">
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="banner-list-item-content-line"></div>
          <div class="banner-list-item-content-buttons">
            <el-button @click="rowDel(item,index)"
                      v-if="permissions.basic_banner_delete" size="small">删除</el-button>
            <el-button @click="handleEdit(item,index)"
                      v-if="permissions.basic_banner_edit" size="small">{{item.isEdit ? "完成" : "编辑"}}</el-button>
          </div>
        </div>
      </div>
      <div class="banner-list-bottom">
        <div class="banner-list-bottom-button">
          <el-button @click="handleSaveAndPublish()"
                      size="small"
                    v-if="permissions.basic_banner_edit || permissions.basic_banner_delete || permissions.basic_banner_add"
          >保存并发布</el-button>
        </div>
      </div>
    </div>
    <material-selector v-if="showMaterialSelector"
                      type="picture"
                      :visible="showMaterialSelector"
                      :accept="['jpg', 'jpeg', 'png', 'gif']"
                      @close="handleMaterialSelectorClose"
                      @confirm-select="handleConfirmSelect"></material-selector>
  </div>
</template>

<script>
  import { fetchList, saveAndPublish, syncBannerCache, removeBannerCache } from '@/api/basic/banner'
  import { mapGetters } from 'vuex'
  import MaterialSelector from '@/components/material-selector/MaterialSelector.vue'
  export default {
    components: {
      MaterialSelector
    },
    data() {
      return {
        total: '',
        tableData: [],
        listQuery: {
          type: 0
        },
        link: '',
        description: '',
        descriptionEn: '',
        sort: '',
        startTime: '',
        endTime: '',
        showMaterialSelector: false
      }
    },
    mounted: function() {
      this.getList()
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      onClickSyncCache() {
        var _this = this;
        _this.$confirm('请确认是否需要启用缓存？如有更新操作需重新同步。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(function () {
          return syncBannerCache({ type: _this.listQuery.type });
        }).then(() => {
          _this.$message({
            showClose: true,
            message: '同步成功',
            type: 'success',
          });
        }).catch(function (err) {
          if (err == 'cancel') {
            return;
          }
          _this.$message({
            showClose: true,
            message: '同步失败',
            type: 'error',
          });
        });
      },
      onClickRemoveCache() {
        var _this = this;
        _this.$confirm('请确认是否禁用缓存？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(function () {
          return removeBannerCache({ type: _this.listQuery.type });
        }).then(() => {
          _this.$message({
            showClose: true,
            message: '禁用成功',
            type: 'success',
          });
        }).catch(function (err) {
          if (err == 'cancel') {
            return;
          }
          _this.$message({
            showClose: true,
            message: '禁用失败',
            type: 'error',
          });
        });
      },
      async getList() {
        fetchList(this.listQuery).then(response => {
          this.tableData = []
          for (var item of response.data.data) {
            item.isEdit = false;
            this.tableData.push(item);
          }
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取列表失败',
            type: 'error'
          })
        })
      },
      handleEdit(item,index) {
        item.isEdit = !item.isEdit
        if (!item.isEdit) {
          let _this = this
          if (item.startTime && item.endTime) {
            if (new Date(item.startTime).getTime() > new Date(item.endTime).getTime()) {
              _this.$message({
                showClose: true,
                message: '开始时间不能大于结束时间',
                type: 'warning'
              })
              item.isEdit = true
            }
          }
        }
      },
      rowDel: function(row,index) {
        var _this = this
        this.$confirm('是否确认删除该图片?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.splice(index,1)
        })
      },
      handleConfirmSelect (materialList) {
        this.showMaterialSelector = false;
        for (const material of materialList) {
          let item = {
            imgUrl: material.contentUrl,
            description: '',
            descriptionEn: '',
            insertedTime: '',
            startTime: '',
            endTime: '',
            isEdit: false,
            link: "",
            name: "",
            sort: 0,
            type: 0
          };
          this.tableData.unshift(item);
        }
      },
      handleSaveAndPublish() {
        var _this = this
        var canSave = true
        this.tableData.forEach(element => {
          if (element.isEdit) {
            _this.$message({
              showClose: true,
              message: '您有未保存的编辑，请保存后再发布',
              type: 'warning'
            })
            canSave = false
          }
        });
        if (!canSave) {
          return
        }
        this.$confirm('是否确认保存并发布?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          saveAndPublish(this.tableData).then(response => {
            if (response.data.data) {
              _this.$message({
                showClose: true,
                message: '保存并发布成功',
                type: 'success'
              })
              this.getList();
            }
          }).catch(function(err) {
            console.error(err)
            _this.$message({
              showClose: true,
              message: '保存并发布失败',
              type: 'error'
            })
          })
        })
      },
      handleMaterialSelectorClose () {
        this.showMaterialSelector = false;
      }
    },
  }

</script>

<style lang="scss" scoped>
button {
  background: #409EFF;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
}

.lableText {
  padding-left: 16px;
}

.banner {
  font-family: Source Han Sans CN;
  color: #3B3B3B;

  &-list{
    font-size: 14px;
    &-top {
      font-size: 14px;
      background: #ffffff;
      height: 50px;
      width: calc(100% - 30px) !important;
      margin-left: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 10px;
      &-left{
        margin-left: 30px;
      }
      &-right{
        margin-right: 30px;
        display: flex;
        justify-content: flex-between;
        align-items: center;
      }
    }
    &-item {
      font-size: 14px;
      background: #ffffff;
      width: calc(100% - 30px) !important;
      margin-left: 15px;
      &-content {
        border-top: 1px solid #eeeeee;
        margin-left: 15px;
        width: calc(100% - 30px) !important;
        height: 164px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        &-img {
          height: 124px;
          width: 180px;
        }
        &-description {
          border-right: 1px dotted #eeeeee;
          height: 124px;
          width: 690px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          &-row {
            display: flex;
            justify-content: space-between;
            line-height: 38px;
            height: 38px;
            &-input {
              width: 270px;
            }
            &-input-en {
              width: 214px;
            }
            &-date {
              width: 270px !important;
            }
            &-left {
              flex: 1;
            }
            &-right {
              flex: 1;
            }
          }
        }
        &-buttons {
          padding-top: 40px;
          height: 90px;
          width: 100px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          button {
            margin-left: 0px !important;
          }
        }
      }
    }
    &-bottom {
      width: calc(100% - 30px) !important;
      height: 60px;
      margin-left: 15px;
      display: flex;
      justify-content: flex-end;
      &-button {
        width: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      button {
        font-size: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>